module.exports = __webpack_public_path__ + "img/logo-black.ca57614e.svg";